import React, { useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'

import { useScrollOnNavigate } from '../components/layout'
import Icon from '../components/icon'
import { SITE } from '../site'
import { CATEGORIES, connectorsOf } from './catalog'
import './secretario.css'

// Navegación propia de Secretario; «Comenzar ahora» va a la sección de acceso de la portada.
const NAV = [
  { to: '/secretario', label: 'Inicio', exact: true },
  { to: '/secretario/funcionalidades', label: 'Funcionalidades' },
  { to: '/secretario/aprende', label: 'Aprende a usar Secretario' },
]

export const START_HREF = '/secretario#comenzar'

// Marca de Secretario: el punto verde de su campaña y el nombre.
export const Wordmark = ({ to = '/secretario' }) => (
  <Link to={to} className="sec-wordmark" aria-label="Secretario, inicio">
    <span className="sec-wordmark__dot" aria-hidden="true" />
    <span>Secretario</span>
  </Link>
)

const Header = () => {
  const [open, setOpen] = useState(false)
  const { pathname, hash } = useLocation()

  useEffect(() => setOpen(false), [pathname, hash])

  return (
    <header className="sec-header">
      <div className="container sec-header__inner">
        <div className="sec-header__brand">
          <Wordmark />
          <Link to="/" className="sec-header__by">
            por Variant
          </Link>
        </div>
        <nav className={`sec-nav${open ? ' is-open' : ''}`} aria-label="Secretario">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              exact={item.exact}
              className="sec-nav__link"
              activeClassName="is-active"
            >
              {item.label}
            </NavLink>
          ))}
          <Link to={START_HREF} className="sec-btn sec-btn--accent sec-btn--sm">
            Comenzar ahora
          </Link>
        </nav>
        <button
          type="button"
          className="sec-menu-toggle"
          aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <Icon name={open ? 'close' : 'menu'} size={22} />
        </button>
      </div>
    </header>
  )
}

const Footer = () => (
  <footer className="sec-footer">
    <div className="container">
      <div className="sec-footer__grid">
        <div className="sec-footer__brand">
          <Wordmark />
          <p>Tu asistente personal en WhatsApp. Tú escribes, Secretario se encarga.</p>
          <Link to="/" className="sec-footer__variant">
            <img src="/logo-variant.png" alt="" width="20" height="20" />
            Un producto de Variant
          </Link>
        </div>
        <div>
          <h4>Producto</h4>
          <Link to="/secretario">Inicio</Link>
          <Link to="/secretario/funcionalidades">Funcionalidades</Link>
          <Link to="/secretario#permisos">Permisos y privacidad</Link>
          <Link to={START_HREF}>Comenzar ahora</Link>
        </div>
        <div>
          <h4>Aprende</h4>
          {CATEGORIES.filter((c) => connectorsOf(c.id).length > 0).map((c) => (
            <Link key={c.id} to={`/secretario/aprende/${connectorsOf(c.id)[0].id}`}>
              {c.name}
            </Link>
          ))}
        </div>
        <div>
          <h4>Ayuda</h4>
          <Link to="/secretario#preguntas">Preguntas frecuentes</Link>
          <a href={`mailto:${SITE.email}?subject=Ayuda%20con%20Secretario`}>{SITE.email}</a>
          <a href={`https://wa.me/${SITE.whatsapp}`} target="_blank" rel="noopener noreferrer">
            WhatsApp {SITE.whatsappDisplay}
          </a>
          <Link to="/politica-de-privacidad">Política de privacidad</Link>
          <Link to="/terminos">Términos y condiciones</Link>
        </div>
      </div>
      <div className="sec-footer__bottom">
        © {new Date().getFullYear()} {SITE.legalName} Secretario es un producto de Variant.
      </div>
    </div>
  </footer>
)

const SecretarioLayout = ({ children }) => {
  useScrollOnNavigate()
  return (
    <div className="sec">
      <a href="#contenido" className="sec-skip">
        Saltar al contenido
      </a>
      <Header />
      <main id="contenido">{children}</main>
      <Footer />
    </div>
  )
}

export default SecretarioLayout
